import { type FC, useMemo } from "react";
import { ContentType, type PeopleType } from "../../../../features/Library/PeopleAssignments/types";
import { type IScormAssignmentModelItem } from "../../../../features/People/types";
import dateTimeUtils from "../../../../utils/dateTimeUtils";
import { type ScormCardBaseProps } from "../../../cards/ScormCard/types";
import PublishStatusCard from "../../../cards/PublishStatusCard";
import ExpiresCardTemplate from "../../../ExpiresTemplate/ExpiresCardTemplate/ExpiresCardTemplate";
import getCardPriorityIcon from "../../priority/getCardPriorityIcon";

import { RouteNames } from "enums";

import "./peopleScormCard.scss";
import styles from "../../../cards/ScormCard/ScormCard.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolderOpen } from "@fortawesome/pro-solid-svg-icons";

export interface PeopleScormCardProps extends ScormCardBaseProps<IScormAssignmentModelItem> {
  peopleType: PeopleType;
  showExpirationDate?: boolean;
  showAdded?: boolean;
  deepLink?: boolean;
}

export const PeopleScormCard: FC<PeopleScormCardProps> = (props: PeopleScormCardProps): React.ReactElement => {
  const { showExpirationDate, onSelect, item, selected, disabled, peopleType, showAdded, selectable, deepLink } = props;

  const { id, isDraft, dateCreated, expirationDate, priorityLevelId, dueDate } = item;

  const icons = useMemo(
    () => [
      getCardPriorityIcon({
        peopleType,
        contentType: ContentType.Scorm,
        priority: priorityLevelId,
        dueDate,
        tooltipClass: "people-scorm-priority-tooltip",
        showNone: false,
      }),
    ],
    [dueDate, peopleType, priorityLevelId],
  );

  return (
    <PublishStatusCard
      {...item}
      id={id}
      url={!item.inherited && deepLink ? `/${RouteNames.contentScorm}/${id}` : undefined}
      className="people-scorm-card"
      onSelectionChanged={onSelect}
      disablePopupMenu={selected}
      published={!isDraft}
      icons={icons}
      selected={selected}
      disabled={disabled}
      selectable={selectable}
      isHidden={!item.visibility}
      placeholderContent={
        <div className={styles.thumbnailBlock}>
          <FontAwesomeIcon icon={faFolderOpen} color={"#686569"} size={"3x"} />
        </div>
      }
    >
      {showExpirationDate && <ExpiresCardTemplate expirationDate={expirationDate} />}
      {showAdded && <div>Added {dateTimeUtils.formatDate(dateCreated)}</div>}
    </PublishStatusCard>
  );
};
